var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('my-header'),_vm._v(" "),_c('div',{staticClass:"about"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("关于我们")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$store.state.config.about)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }